<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Название:</label>
              <input
                @keyup.enter="apply"
                class="form-control"
                v-model="currFilters.name"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Активность:</label>
              <select class="form-control" v-model="currFilters.active">
                <option v-for="item in yesNoList" :value="item.id">
                  {{ item.text }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer d-flex justify-content-between">
        <button-component class="col-6" @click="apply">
          Применить
        </button-component>
        <button-component class="col-6" kind="secondary" @click="reset">
          Сбросить
        </button-component>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from "../../../common/constants";
import ButtonComponent from "@/common/ui/ButtonComponent";

export default {
  name: "RolesFilter",
  components: { ButtonComponent },
  props: {
    filters: Object,
  },
  data() {
    return {
      currFilters: this.filters,
      yesNoList: Constants.yesNoList,
    };
  },
  methods: {
    apply() {
      const filters = Object.assign({}, this.currFilters);
      this.$emit("apply", filters);
    },
    reset() {
      this.currFilters = {
        name: "",
        active: null,
      };
      const filters = Object.assign({}, this.currFilters);
      this.$emit("reset", filters);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "src/assets/theme/default/colors";

.form-group {
  label {
    font-weight: 400 !important;
    color: $gray-dark;
    font-size: 16px;
  }
}

.card-footer {
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}
</style>
